/**
 * The reads that live in their own `catalog-*.ts` files, joined in one list so `catalog.ts` takes a single
 * spread (it sits on its 500-line lint ceiling). Order matches how they were first appended; nothing here
 * shadows another, and `catalog.ts` still sorts every static segment ahead of its `:param` siblings.
 */
import type { ReadRoute } from "./catalog";
import { ACCEPT_JOB_READ_ROUTES } from "./catalog-accept-jobs";
import { EIN_CORRECTION_READ_ROUTES } from "./catalog-ein-corrections";
import { EMAIL_READ_ROUTES } from "./catalog-email";
import { FORM_7004_READ_ROUTES } from "./catalog-form-7004";
import { MAIL_READ_ROUTES } from "./catalog-mail";
import { PENALTY_NOTICES_READ_ROUTES } from "./catalog-penalty-notices";
import { PARTNER_READ_ROUTES } from "./catalog-partners";
import { PLATFORM_STATUS_READ_ROUTES } from "./catalog-platform-status";
import { TAX_YEAR_WAITLIST_READ_ROUTES } from "./catalog-tax-year-waitlist";

export const SPLIT_READ_ROUTES: readonly ReadRoute[] = [
  ...PARTNER_READ_ROUTES,
  ...EMAIL_READ_ROUTES,
  ...EIN_CORRECTION_READ_ROUTES,
  ...FORM_7004_READ_ROUTES,
  ...TAX_YEAR_WAITLIST_READ_ROUTES,
  ...ACCEPT_JOB_READ_ROUTES,
  ...MAIL_READ_ROUTES,
  ...PENALTY_NOTICES_READ_ROUTES,
  ...PLATFORM_STATUS_READ_ROUTES,
];
